import { Provider } from "react-redux";
import { ThemeProvider } from "@mui/material/styles";
import themeConfig from "./ColorsConfig";
import { AppRouter } from "./routers/AppRouter";
import { store } from "./store/store";
import "./App.css";

function App() {
  return (
    <Provider store={store}>
      <ThemeProvider theme={themeConfig}>
        <AppRouter />
      </ThemeProvider>
    </Provider>
  );
}

export default App;
